module.exports = __webpack_public_path__ + "img/img1.17343a33.png";